import { AuthProvider } from "@/context/AuthContext";
import { AppRouter } from "@/routes";

export function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
